import { Pipe, PipeTransform } from '@angular/core';
import { DvirStatusOptions, SelectOption } from '@fleet-beat/core';

@Pipe({
  name: 'dvirStatusPipe',
})
export class DvirStatusPipe implements PipeTransform {
  transform(value: unknown): string | null {
    if (!value) return null;
    return DvirStatusOptions.find((status: SelectOption) => status.value === value).label;
  }
}
